import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setChannelList,
  setSelectedChannel,
} from "../../redux/designerPropertiesSlice";
import ChannelItem from "./ChannelItem";
import store from "../../redux/store";

const ChannelSelector: React.FC<{ onManageClick: () => void }> = ({
  onManageClick,
}) => {
  const channelList = useSelector((state: any) => state.properties.channelList);

  const selectChannel = (updatedChannel: any, index: number) => {
    const updatedList = channelList.map((channel: any, i: number) => {
      let channelToUpdate = { ...channel };
      i === index
        ? (channelToUpdate.selected = true)
        : (channelToUpdate.selected = false);
      return { ...channel, ...channelToUpdate };
    });
    store.dispatch(setSelectedChannel({ ...updatedChannel }));
    store.dispatch(setChannelList(updatedList));
  };

  return (
    <>
      <div className="header">
        <button className="manage-button" onClick={onManageClick}>
          <span className="gear-icon">⚙️</span> Canales
        </button>
      </div>
      <div className="channel-list">
        {channelList.map((channel: any, index: number) => (
          <ChannelItem
            key={channel.key}
            channel={channel}
            selectChannel={selectChannel}
            index={index}
          />
        ))}
      </div>
    </>
  );
};

export default ChannelSelector;
